import { render, staticRenderFns } from "./HaveQuestionsForm.vue?vue&type=template&id=a982184c&"
import script from "./HaveQuestionsForm.vue?vue&type=script&lang=js&"
export * from "./HaveQuestionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports